import { useCallback, useEffect, useState } from 'react';
import { Exam } from '../../shared/ExamModuleTypes';
import { useAuth } from '../../hooks/useAuth';
import { useCallApi } from '../../hooks/useCallApi';
import { getActiveExam } from '../../service/ExamModuleService';
import useUserSession from '../../hooks/useUserSession';

export const useExamModule = () => {
	const [activeExam, setActiveExam] = useState<Exam>();
	const { srcmId } = useAuth();
	const { selectedRole } = useUserSession();
	const { callApi } = useCallApi();

	const fetchActiveExam = useCallback(async () => {
		if (srcmId && selectedRole) {
			const response = await callApi(
				() =>
					getActiveExam({
						srcmId,
						selectedRoleCode: selectedRole,
					}),
				'errorOccurredWhileLoading'
			);
			setActiveExam(response);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [srcmId, selectedRole]);

	useEffect(() => {
		if (srcmId) {
			void fetchActiveExam();
		}
	}, [fetchActiveExam, srcmId]);

	return { activeExam, fetchActiveExam };
};
